import React, { useState, useEffect, useRef } from 'react';

import useAuth from '../../hooks/useAuth';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FaHeart, FaShare, FaMapMarkerAlt, FaBed, FaBath, FaRuler, FaWineBottle, FaParking, FaImages, FaHome, FaCalendarAlt, FaSnowflake, FaUser, FaWhatsapp, FaArrowLeft, FaFacebook, FaTwitter, FaLinkedin, FaPinterest, FaTelegram, FaCopy, FaTimes,
  FaShower, FaWifi, FaDoorOpen, FaGamepad, FaDoorClosed, FaChild, FaSubway, FaArrowUp, FaWarehouse, FaFutbol, FaGlassCheers, FaDumbbell, FaHotTub, FaPaw, FaBuilding,
  FaPhone, FaEnvelope, FaGlobe, FaInstagram, FaExternalLinkAlt
} from 'react-icons/fa';
import './styles.css';
import PhotoViewerModal from './PhotoViewerModal';
import Slider from 'react-slick';
import PropertyCard from '../../components/FeaturedHomes/card';
import AvailabilityCalendar from '../../components/AvailabilityCalendar';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// Calendário estilo Airbnb
import { DateRange } from 'react-date-range';
import { createPortal } from 'react-dom';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import Swal from 'sweetalert2';
import { useCurrency } from '../../contexts/CurrencyContext';
import { normalizeFavorites } from '../../utils/favorites';

// Importando as imagens
import img01 from '../../assets/imoveis/01.webp';
import img02 from '../../assets/imoveis/02.webp';
import img03 from '../../assets/imoveis/03.webp';
import img04 from '../../assets/imoveis/03.webp';
import img05 from '../../assets/imoveis/03.webp';

const ShareModal = ({ isOpen, onClose, url }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = React.useRef(null);

  const handleCopyLink = async () => {
    setCopied(false);
    // Tenta usar a API moderna
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        return;
      }
    } catch {
      // ignora e tenta fallback
    }

    // Fallback via textarea + execCommand
    try {
      const el = document.createElement('textarea');
      el.value = url;
      el.style.position = 'fixed';
      el.style.top = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      return;
    } catch {
      // Último recurso: seleciona o input visível para o usuário copiar manualmente
      try {
        inputRef.current?.select();
        inputRef.current?.setSelectionRange(0, url.length);
      } catch {
        // Ignore selection errors
      }
      setCopied(false);
    }
  };

  

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal-overlay') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="share-modal">
        <div className="modal-header">
          <h3>Compartilhar</h3>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
          </div>
        <div className="share-options">
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${url}`} target="_blank" rel="noopener noreferrer" className="share-option facebook">
            <FaFacebook />
            <span>Facebook</span>
          </a>
          <a href={`https://twitter.com/intent/tweet?url=${url}`} target="_blank" rel="noopener noreferrer" className="share-option twitter">
            <FaTwitter />
            <span>Twitter</span>
          </a>
          <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target="_blank" rel="noopener noreferrer" className="share-option linkedin">
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <a href={`https://pinterest.com/pin/create/button/?url=${url}`} target="_blank" rel="noopener noreferrer" className="share-option pinterest">
            <FaPinterest />
            <span>Pinterest</span>
          </a>
          <a href={`https://t.me/share/url?url=${url}`} target="_blank" rel="noopener noreferrer" className="share-option telegram">
            <FaTelegram />
            <span>Telegram</span>
          </a>
          <a href={`https://wa.me/?text=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" className="share-option whatsapp">
            <FaWhatsapp />
            <span>WhatsApp</span>
          </a>
          <button type="button" onClick={handleCopyLink} className="share-option copy">
            <FaCopy />
            <span>{copied ? 'Copiado!' : 'Copiar Link'}</span>
          </button>
        </div>
        <div style={{ marginTop: 12 }}>
          <input
            ref={inputRef}
            type="text"
            readOnly
            value={url}
            onFocus={(e)=> e.target.select()}
            style={{ width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }}
            aria-label="Link da página"
          />
          <small style={{ color: '#6b7280' }}>Se não copiar automaticamente, selecione e copie o link acima.</small>
        </div>
      </div>
    </div>
  );
};

const PropertyContent = () => {
  const { isLoggedIn, user } = useAuth();
  const globalState = useGlobalState();
  const handleOpenLogin = globalState?.handleOpenLogin || (() => {});
  const currentUser = user || globalState?.user;
  const [favorites, setFavorites] = useState([]);

  // Normalização explícita de booleanos para evitar problemas com valores como 0, "0", null, undefined
  const toBoolean = (value) => {
    return value === true || value === 1 || value === '1' || value === 'true';
  };

  // Buscar favoritos do usuário ao carregar
  useEffect(() => {
    const fetchFavorites = async () => {
      if (!isLoggedIn || !user) return;
      const token = localStorage.getItem('auth_token');
      try {
        const res = await fetch(`${import.meta.env.VITE_URL_API}/favoritos/usuario/${user.codigo || user.id || user.userId}`, {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        setFavorites(normalizeFavorites(data));
      } catch {
        setFavorites([]);
      }
    };
    fetchFavorites();
  }, [isLoggedIn, user]);

  // Favoritar
  const handleFavorite = async (propertyId) => {
    if (!isLoggedIn) {
      handleOpenLogin();
      return;
    }
    try {
      const token = localStorage.getItem('auth_token');
      const payload = {
        imovelFAVORITO: propertyId,
        usuarioFAVORITO: user?.codigo || user?.id || user?.userId,
        ativoFAVORITO: 1
      };
      const response = await fetch(`${import.meta.env.VITE_URL_API}/favoritos`, {
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        // Atualize favoritos após favoritar
        const res = await fetch(`${import.meta.env.VITE_URL_API}/favoritos/usuario/${payload.usuarioFAVORITO}`, {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        setFavorites(normalizeFavorites(data));
        window.dispatchEvent(new Event('favoritesChanged'));
        try {
          const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
          if (isMobile) {
            Swal.fire({
              icon: 'success',
              title: 'Imóvel adicionado aos favoritos',
              confirmButtonText: 'OK',
              width: '90%',
              timer: 2000,
              timerProgressBar: true,
            });
          } else {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              title: 'Adicionado aos favoritos',
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch {
          // Ignore Swal errors
        }
      } else {
        try {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao favoritar',
            text: 'Tente novamente em instantes.',
            width: '90%',
          });
        } catch {
          // Ignore Swal errors
        }
      }
    } catch (err) {
      try {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao favoritar',
          text: 'Tente novamente em instantes.',
          width: '90%',
        });
      } catch {
        // Ignore Swal errors
      }
    }
  };

  // Desfavoritar
  const handleUnfavorite = async (propertyId) => {
    if (!isLoggedIn) {
      handleOpenLogin();
      return;
    }
    try {
      const token = localStorage.getItem('auth_token');
      // Descubra o codigoFAVORITO pelo imovel
      const fav = favorites.find(f => String(f.imovelFAVORITO) === String(propertyId));
      if (!fav) return;
      await fetch(`${import.meta.env.VITE_URL_API}/favoritos/${fav.codigoFAVORITO}`, {
        method: 'DELETE',
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      });
      // Atualize favoritos após remover
      const res = await fetch(`${import.meta.env.VITE_URL_API}/favoritos/usuario/${user.codigo || user.id || user.userId}`, {
        headers: {
          'accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setFavorites(normalizeFavorites(data));
      window.dispatchEvent(new Event('favoritesChanged'));
      try {
        const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
        if (isMobile) {
          Swal.fire({
            icon: 'info',
            title: 'Imóvel removido dos favoritos',
            confirmButtonText: 'OK',
            width: '90%',
            timer: 2000,
            timerProgressBar: true,
          });
        } else {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'info',
            title: 'Removido dos favoritos',
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch {
        // Ignore Swal errors
      }
    } catch (err) {
      try {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao remover favorito',
          text: 'Tente novamente em instantes.',
          width: '90%',
        });
      } catch {
        // Ignore Swal errors
      }
    }
  };

  // Helper para saber se está favoritado
  const isFavorited = (propertyId) => favorites.some(fav => String(fav.imovelFAVORITO) === String(propertyId));
  const location = useLocation();
  const { id } = useParams();
  const { t: _t } = useTranslation();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [contactError, setContactError] = useState('');
  const [_contactSuccess, setContactSuccess] = useState('');
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [phoneFromProfile, setPhoneFromProfile] = useState(false);
  const [contactText, setContactText] = useState('');
  const [isPhotoViewerOpen, setIsPhotoViewerOpen] = useState(false);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);

  // Estado para os dados do imóvel
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Restaura rascunho de reserva se existir (após login)
  useEffect(() => {
    try {
      // Pré-preenche contato com dados do usuário logado
      if (user) {
        const nm = user?.nome || user?.name || '';
        const em = user?.email || user?.emailUSUARIO || '';
        const ph = user?.telefone || user?.phone || user?.telefoneUSUARIO || '';
        if (nm) setContactName(nm);
        if (em) setContactEmail(em);
        if (ph) { setContactPhone(ph); setPhoneFromProfile(true); }
      }
      const draftRaw = localStorage.getItem('reservation_draft');
      if (draftRaw) {
        const draft = JSON.parse(draftRaw);
        if (draft?.checkin) setCheckin(draft.checkin);
        if (draft?.checkout) setCheckout(draft.checkout);
        if (draft?.guests) setGuests(draft.guests);
        if (draft?.guestMessage) setGuestMessage(draft.guestMessage);
      }
    } catch {
      // Ignore draft parsing errors
    }
  }, [user, currentUser]);

  // Quando o usuário autenticar depois do mount, pré-preenche também
  useEffect(() => {
    if (!currentUser) return;
    try {
      const nm = currentUser?.nome || currentUser?.name || currentUser?.nomeUSUARIO || '';
      const em = currentUser?.email || currentUser?.emailUSUARIO || '';
      const ph = currentUser?.telefone || currentUser?.phone || currentUser?.telefoneUSUARIO || currentUser?.celular || '';
      if (nm) setContactName((prev)=> prev || nm);
      if (em) setContactEmail((prev)=> prev || em);
      if (ph) { setContactPhone((prev)=> prev || ph); setPhoneFromProfile(true); }
    } catch {
      // Ignore draft parsing errors
    }
  }, [currentUser]);

  useEffect(() => {
    // Garante que ao entrar nesta página o scroll comece do topo
    try { window.scrollTo({ top: 0, behavior: 'auto' }); } catch {
      // Ignore scroll errors
    }
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('auth_token');
    const headers = {
      accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
    const url = `${import.meta.env.VITE_URL_API}/imoveis/${id}`;
    fetch(url, { headers })
      .then(async res => {
        if (!res.ok) {
          const text = await res.text();
          console.error('Falha ao buscar imóvel', { status: res.status, url, text });
          // Se não encontrou, usa um fallback mockado para não deixar a página vazia
          if (res.status === 404) {
            return { __fallback: true };
          }
          throw new Error('Erro ao buscar imóvel');
        }
        return res.json();
      })
      .then(data => {
        if (data && data.__fallback) {
          // Monta um objeto de imóvel mínimo para exibição
          const fallback = {
            codigoIMOVEL: Number(id),
            dadosBasicos: {
              tituloIMOVEL: 'Imóvel indisponível no momento',
              descricaoIMOVEL: 'Este imóvel não foi encontrado na base de dados. Exibindo visualização demonstrativa.',
              valorIMOVEL: 0,
            },
            enderecos: {
              enderecoIMOVEL: 'Endereço não informado',
              cidadeIMOVEL: '—'
            },
            caracteristicas: {
              quartosIMOVEL: 0,
              banheirosIMOVEL: 0,
              metragemIMOVEL: 0,
              vagasgaragemIMOVEL: 0,
            },
            fotos: [
              { urlFOTO: img01 },
              { urlFOTO: img02 },
              { urlFOTO: img03 },
              { urlFOTO: img04 },
              { urlFOTO: img05 },
            ]
          };
          setPropertyData(fallback);
          setLoading(false);
          return;
        }

        // API pode retornar objeto ou array (ou data/items/Registros)
        const pickFirst = (payload) => {
          if (Array.isArray(payload)) return payload[0] || null;
          if (Array.isArray(payload?.data)) return payload.data[0] || null;
          if (Array.isArray(payload?.items)) return payload.items[0] || null;
          if (Array.isArray(payload?.Registros)) return payload.Registros[0] || null;
          return payload || null;
        };

        const normalized = pickFirst(data);
        if (!normalized) {
          // Sem dados válidos -> usa fallback
          const fallback = {
            codigoIMOVEL: Number(id),
            dadosBasicos: {
              tituloIMOVEL: 'Imóvel indisponível no momento',
              descricaoIMOVEL: 'Este imóvel não foi encontrado na base de dados. Exibindo visualização demonstrativa.',
              valorIMOVEL: 0,
            },
            enderecos: {
              enderecoIMOVEL: 'Endereço não informado',
              cidadeIMOVEL: '—'
            },
            caracteristicas: {
              quartosIMOVEL: 0,
              banheirosIMOVEL: 0,
              metragemIMOVEL: 0,
              vagasgaragemIMOVEL: 0,
            },
            fotos: [
              { urlFOTO: img01 },
              { urlFOTO: img02 },
              { urlFOTO: img03 },
              { urlFOTO: img04 },
              { urlFOTO: img05 },
            ]
          };
          setPropertyData(fallback);
          setLoading(false);
          return;
        }

        // Flatten the data structure to match EditListing behavior
        // This ensures fields like limpezaCobrada, valorLimpeza, etc. are accessible at root level
        const flattened = {
          ...normalized.dadosBasicos,
          ...normalized.enderecos,
          ...normalized.caracteristicas,
          fotos: normalized.fotos || [],
          midia: normalized.midia,
          agente: normalized.agente,
          imobiliaria: normalized.imobiliaria,
          host: normalized.host,
          reviews: normalized.reviews,
          metricas: normalized.metricas,
          categoria: normalized.categoria,
          // Copy root-level fields that may not be in the nested objects
          codigoIMOVEL: normalized.codigoIMOVEL,
          // limpezaCobrada, valorLimpeza, taxaTurismoCobrada, etc. já são copiados via ...normalized.caracteristicas
          // Não copiamos do nível raiz para evitar sobrescrever com undefined
          permanenciaminimaIMOVEL:
            normalized.permanenciaminimaIMOVEL !== undefined
              ? normalized.permanenciaminimaIMOVEL
              : (normalized.dadosBasicos?.permanenciaminimaIMOVEL ?? normalized.caracteristicas?.permanenciaminimaIMOVEL),
          permanenciamaximaIMOVEL:
            normalized.permanenciamaximaIMOVEL !== undefined
              ? normalized.permanenciamaximaIMOVEL
              : (normalized.dadosBasicos?.permanenciamaximaIMOVEL ?? normalized.caracteristicas?.permanenciamaximaIMOVEL),
          checkinIMOVEL: normalized.checkinIMOVEL,
          checkoutIMOVEL: normalized.checkoutIMOVEL,
          instantBooking: normalized.instantBooking,
          politicacancelamentoIMOVEL: normalized.politicacancelamentoIMOVEL,
          regrasadicionaisIMOVEL: normalized.regrasadicionaisIMOVEL ?? normalized.dadosBasicos?.regrasadicionaisIMOVEL,
          labelvalorIMOVEL: normalized.labelvalorIMOVEL,
          ativoIMOVEL: normalized.ativoIMOVEL,
          planoIMOVEL: normalized.planoIMOVEL,
          pacoteIMOVEL: normalized.pacoteIMOVEL,
          clienteIMOVEL: normalized.clienteIMOVEL,
          idIMOVEL: normalized.idIMOVEL,
          slugIMOVEL: normalized.slugIMOVEL,
          tipoIMOVEL: normalized.tipoIMOVEL ?? normalized.dadosBasicos?.tipoIMOVEL,
          // Campos de caracteristicas já são copiados via ...normalized.caracteristicas acima
          // Não copiamos do nível raiz para evitar sobrescrever com undefined
          countryIMOVEL: normalized.countryIMOVEL,
          paisIMOVEL: normalized.paisIMOVEL,
          exibirPreco: normalized.exibirPreco,
          // afiliação (anúncio importado — ex.: Airbnb)
          afiliacao: normalized.afiliacao || null,
          fonteIMOVEL: normalized.fonteIMOVEL,
          urlFonteIMOVEL: normalized.urlFonteIMOVEL,
          externalIdIMOVEL: normalized.externalIdIMOVEL,
        };

        console.log('Dados retornados da API:', normalized); // <-- Log para depuração
        console.log('Dados achatados (flattened):', flattened); // <-- Log para depuração
        console.log('Campos específicos:', {
          quartosIMOVEL: flattened.quartosIMOVEL,
          casadebanhoIMOVEL: flattened.casadebanhoIMOVEL,
          solteirocamasIMOVEL: flattened.solteirocamasIMOVEL,
          casalcamasIMOVEL: flattened.casalcamasIMOVEL,
          vagasgaragemIMOVEL: flattened.vagasgaragemIMOVEL
        });
        console.log('🧹 Dados públicos do anúncio:', flattened);
        console.log('🧹 Limpeza cobrada (raw):', flattened.limpezaCobrada);
        console.log('🧹 Valor limpeza:', flattened.valorLimpeza);
        console.log('🧹 Taxa turismo cobrada (raw):', flattened.taxaTurismoCobrada);
        console.log('🧹 Valor adulto:', flattened.valorTaxaTurismoAdulto);
        console.log('🧹 Valor criança:', flattened.valorTaxaTurismoCrianca);
        console.log('🧹 Idade máxima:', flattened.idadeMaximaCrianca);
        console.log('🧹 Valores originais da API:', {
          limpezaCobrada: normalized.limpezaCobrada,
          valorLimpeza: normalized.valorLimpeza,
          taxaTurismoCobrada: normalized.taxaTurismoCobrada,
          valorTaxaTurismoAdulto: normalized.valorTaxaTurismoAdulto,
          valorTaxaTurismoCrianca: normalized.valorTaxaTurismoCrianca,
          idadeMaximaCrianca: normalized.idadeMaximaCrianca
        });
        console.log('Conteúdo completo de normalized.caracteristicas:', JSON.stringify(normalized.caracteristicas, null, 2));
        console.log('Conteúdo completo de normalized.dadosBasicos:', JSON.stringify(normalized.dadosBasicos, null, 2));
        console.log('Verificando estrutura aninhada:', {
          'normalized.caracteristicas': normalized.caracteristicas,
          'normalized.dadosBasicos': normalized.dadosBasicos,
          'normalized.quartosIMOVEL': normalized.quartosIMOVEL,
          'normalized.casadebanhoIMOVEL': normalized.casadebanhoIMOVEL,
          'normalized.solteirocamasIMOVEL': normalized.solteirocamasIMOVEL,
          'normalized.casalcamasIMOVEL': normalized.casalcamasIMOVEL,
          'normalized.vagasgaragemIMOVEL': normalized.vagasgaragemIMOVEL
        });
        setPropertyData(flattened);
        setLoading(false);
      })
      .catch(err => {
        console.error('Erro ao carregar dados do imóvel:', err); // <-- Log de erro
        setError('Erro ao carregar dados do imóvel');
        setLoading(false);
      });
  }, [id, location?.state?.property]);

  // Busca disponibilidade do imóvel (reservas ativas)
  useEffect(() => {
    if (!id) return;
    const token = localStorage.getItem('auth_token');
    const headers = {
      accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
    fetch(`${import.meta.env.VITE_URL_API}/imoveis/${id}/disponibilidade`, { headers })
      .then(res => (res.ok ? res.json() : []))
      .then(data => {
        const list = Array.isArray(data) ? data : data?.data || [];
        setAvailability(list);
      })
      .catch(() => setAvailability([]));
  }, [id]);

  // Utilizar dados da API ou fallback mockado (data is now flattened)
  const titulo = propertyData?.tituloIMOVEL || 'Casa';
  const descricao = propertyData?.descricaoIMOVEL || 'Descrição não disponível';
  const regrasAdicionais = propertyData?.regrasadicionaisIMOVEL || '';
  const valor = propertyData?.valorIMOVEL || 0;
  const _localizacao = propertyData?.enderecoIMOVEL || 'Localização não disponível'; // Usado em renderização
  const quartos = propertyData?.quartosIMOVEL || 0;
  const banheiros = propertyData?.casadebanhoIMOVEL || propertyData?.banheirosIMOVEL || 0;
  const metragem = propertyData?.metragemIMOVEL || 0;
  const vagas = propertyData?.vagasgaragemIMOVEL || 0;
  const fotos = propertyData?.fotos?.map(f => f.urlFOTO || f.pathFOTO || f.url || f.path) || [img01, img02, img03, img04, img05];
  // Tipo do imóvel para regras de calendário/reserva: não mostrar quando tipo 1 ou 2
  const tipoImovel = (
    propertyData?.tipoIMOVEL ??
    propertyData?.categoria?.tipo?.codigo ??
    propertyData?.dadosBasicos?.tipoIMOVEL
  );
  const showBookingAndCalendar = !(Number(tipoImovel) === 1 || Number(tipoImovel) === 2);

  // Imóvel afiliado (importado de fonte externa, ex.: Airbnb): reserva e contato
  // acontecem na plataforma de origem — os botões abrem afiliacao.url em nova aba
  const afiliacao = propertyData?.afiliacao || null;
  const afiliacaoUrl = afiliacao?.url || propertyData?.urlFonteIMOVEL || null;
  const afiliacaoNome = (() => {
    const f = String(afiliacao?.fonte || propertyData?.fonteIMOVEL || '').toLowerCase();
    if (f === 'airbnb') return 'Airbnb';
    if (f === 'imovirtual') return 'Imovirtual';
    if (f === 'casayes') return 'CasaYes';
    if (f === 'idealista') return 'Idealista';
    if (f) return f.charAt(0).toUpperCase() + f.slice(1);
    return 'site externo';
  })();
  const isAfiliado = !!(afiliacao && afiliacaoUrl);
  const openAfiliacao = () => { if (afiliacaoUrl) window.open(afiliacaoUrl, '_blank', 'noopener,noreferrer'); };
  const tipoImovelNome = (
    propertyData?.categoria?.tipo?.nome ||
    (Number(tipoImovel) === 1 ? 'Comprar' : Number(tipoImovel) === 2 ? 'Alugar' : 'Temporada')
  );
  const tipoImovelChip = (() => {
    const slug = (
      propertyData?.categoria?.tipo?.slugTIPOIMOVEL ||
      propertyData?.categoria?.tipo?.slug ||
      propertyData?.slugTIPOIMOVEL ||
      ''
    ).toLowerCase();
    const nome = (propertyData?.categoria?.tipo?.nome || propertyData?.tipoImovelNome || '').toLowerCase();
    if (slug.includes('arr')) return 'ARRENDAR';
    if (slug.includes('ferias') || slug.includes('vacation') || slug.includes('temporada') || nome.includes('ferias') || nome.includes('temporada') || nome.includes('vacation')) return 'FÉRIAS';
    if (slug.includes('compr') || slug.includes('vend')) return 'COMPRAR';
    if (Number(tipoImovel) === 2) return 'ARRENDAR';
    if (Number(tipoImovel) === 1) return 'COMPRAR';
    if (Number(tipoImovel) === 3) return 'FÉRIAS';
    return (tipoImovelNome || '').toUpperCase();
  })();

  const { currency, currencySymbol, exchangeRate } = useCurrency();

  const formatPrice = (val, tipo) => {
    const converted = Math.round(((Number(val) || 0) * exchangeRate + Number.EPSILON) * 100) / 100;
    const formatted = converted.toLocaleString('pt-BR');
    let suffix = '';
    switch (Number(tipo)) {
      case 2:
        suffix = ' /mês';
        break;
      case 1:
      default:
        suffix = '';
        break;
    }
    return `${currencySymbol || currency} ${formatted}${suffix}`;
  };

  // Dados do anfitrião com fallbacks seguros para evitar erros de variável não definida
  // Preferir campos da API atual: agente/imobiliaria
  const rawHostName = propertyData?.agente?.nomeAGENTE || propertyData?.imobiliaria?.nomeIMOBILIARIA || 'Anfitrião';
  const hostName = rawHostName;

  // Host + selo
  const hostInfo = propertyData?.imobiliaria?.host || propertyData?.host || {};
  const hostTipo = (hostInfo.tipo || '').toLowerCase();
  const hostSelo = !!hostInfo.selo || hostTipo === 'superhost';
  const hostRole = hostTipo === 'superhost' ? 'Superhost' : hostTipo === 'gestao_profissional' ? 'Gestão Profissional' : 'Host';

  // Reviews
  const reviewsData = propertyData?.imobiliaria?.reviews || propertyData?.reviews || {};
  const hostReviews = Number(reviewsData.total || 0);
  const hostRating = Number(reviewsData.media || 0) || 0;
  const renderStars = (rating) => {
    const full = Math.round(Math.min(5, Math.max(0, rating)));
    return '★★★★★'.slice(0, full).padEnd(5, '☆');
  };

  const hostAgency = propertyData?.imobiliaria?.nomeIMOBILIARIA;
  const hostLocation = propertyData?.imobiliaria?.enderecoIMOBILIARIA || propertyData?.cidadeIMOVEL;
  // Avatar: foto do agente > logo da imobiliária > iniciais
  const initials = (() => {
    const parts = String(hostName).trim().split(/\s+/).slice(0,2);
    return parts.map(p=>p?.[0]?.toUpperCase()||'').join('') || 'AN';
  })();
  const hostAvatar = propertyData?.agente?.imagemAGENTE || propertyData?.imobiliaria?.imagemIMOBILIARIA || `https://ui-avatars.com/api/?name=${encodeURIComponent(initials)}&background=BA824F&color=fff&format=svg`;

  // Contatos e links (não conflitar com state contactEmail/contactPhone do modal)
  const agentPhone = propertyData?.agente?.telefoneAGENTE || '';
  const agentEmailHost = propertyData?.agente?.emailAGENTE || '';
  const agencyPhone = propertyData?.imobiliaria?.telefoneIMOBILIARIA || '';
  const agencyEmailHost = propertyData?.imobiliaria?.emailIMOBILIARIA || '';
  const hostPhone = agentPhone || agencyPhone;
  const hostEmail = agentEmailHost || agencyEmailHost;

  const [showPhoneNumber, setShowPhoneNumber] = useState(false);

  const maskPhone = (phone) => {
    if (!phone) return '';
    const digits = String(phone).replace(/\D/g, '');
    if (!digits) return '';
    if (digits.length <= 4) return '****';
    return `${digits.slice(0, 4)}-****`;
  };

  const openTel = (raw) => {
    const digits = String(raw||'').replace(/\D+/g, '');
    if (!digits) return;
    const url = `tel:${digits}`;
    try {
      window.location.href = url;
    } catch {
      try { window.open(url, '_self'); } catch {
        // Ignore open errors
      }
    }
  };
  const openMail = (email) => {
    const e = String(email||'').trim();
    if (!e) return;
    try { window.location.href = `mailto:${e}`; } catch {
      // Ignore mailto errors
    }
  };
  const _openLink = (url) => {
    const u = String(url||'').trim();
    if (!u) return;
    const withScheme = /^(https?:)?\/\//i.test(u) ? u : `https://${u}`;
    try { window.open(withScheme, '_blank', 'noopener'); } catch {
      // Ignore open errors
    }
  };

  useEffect(() => {
    setShowPhoneNumber(false);
  }, [hostPhone]);

  const handleRevealPhone = async () => {
    setShowPhoneNumber(true);
    await ensureLeadAndThen(() => {}, 'call');
  };

  const [similarProperties, setSimilarProperties] = useState([]);
  // Estados do formulário de Reserva Instantânea
  const [checkin, setCheckin] = useState('');
  const [checkout, setCheckout] = useState('');
  const [guests, setGuests] = useState(1);
  const [guestMessage, setGuestMessage] = useState('');
  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingMsg, setBookingMsg] = useState('');
  const messageRef = useRef(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const calendarRef = useRef(null);
  const anchorRef = useRef(null);
  const [popoverPos, setPopoverPos] = useState({ top: 0, right: 0 });
  const prevRangeRef = useRef(null);
  const [_calendarWarn, _setCalendarWarn] = useState('');
  // Guests selector
  const [showGuests, setShowGuests] = useState(false);
  const guestsRef = useRef(null);
  const guestsAnchorRef = useRef(null);
  const [adults, setAdults] = useState(1);
  const [childrenCount, setChildrenCount] = useState(0);
  const [babies, setBabies] = useState(0);
  const [pets, setPets] = useState(0);
  const maxGuests = Number(propertyData?.qtdpessoasIMOVEL || 16);
  const totalGuests = Math.max(1, Math.min(maxGuests, adults + childrenCount + babies));
  // Reservas para bloquear datas
  const [reservedRanges, setReservedRanges] = useState([]); // [{start:Date,end:Date,status}]
  const [disabledDates, setDisabledDates] = useState([]); // Date[]
  const [disabledKeys, setDisabledKeys] = useState(new Set()); // Set<string yyyy-mm-dd>
  const [availability, setAvailability] = useState([]);

  // Persiste rascunho da reserva enquanto o usuário preenche
  useEffect(() => {
    try {
      const draft = {
        imovel: propertyData?.codigoIMOVEL,
        checkin,
        checkout,
        guests,
        guestMessage,
      };
      localStorage.setItem('reservation_draft', JSON.stringify(draft));
    } catch {
      // Ignore draft parsing errors
    }
  }, [propertyData?.codigoIMOVEL, checkin, checkout, guests, guestMessage]);

  const dateKey = (dt) => {
    try {
      const y = dt.getFullYear();
      const m = String(dt.getMonth() + 1).padStart(2, '0');
      const d = String(dt.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    } catch { return ''; }
  };

  const openCalendar = () => {
    // Se não estiver logado, abre login e salva retorno/rascunho
    if (!isLoggedIn || !user) {
      try {
        localStorage.setItem('post_login_redirect', window.location.pathname + window.location.search);
        const draft = {
          imovel: propertyData?.codigoIMOVEL,
          checkin,
          checkout,
          guests,
          guestMessage,
        };
        localStorage.setItem('reservation_draft', JSON.stringify(draft));
      } catch {
      // Ignore draft parsing errors
    }
    try { handleOpenLogin(); } catch {
      // Ignore login errors
    }
      return;
    }
    try {
      const rect = anchorRef.current?.getBoundingClientRect();
      if (rect) {
        setPopoverPos({
          top: Math.round(rect.bottom + 10),
          right: Math.max(8, Math.round(window.innerWidth - rect.right)),
        });
      }
    } catch {
      // Ignore draft parsing errors
    }
    setShowCalendar(true);
  };

  // Helpers de data (usados antes em estados/efeitos) — usar declarações de função para hoisting
  function parseDate(str) {
    const match = String(str || '').match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
    if (!match) return null;
    const [, y, m, d] = match.map(Number);
    if (!y || !m || !d) return null;
    // Usa construtor local (ano, mes-1, dia) para evitar offset de fuso
    return new Date(y, m - 1, d);
  }
  function formatDate(dt) {
    if (!(dt instanceof Date)) return '';
    // Garante data apenas com ano/mes/dia em horário local
    const local = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
    const y = local.getFullYear();
    const m = String(local.getMonth() + 1).padStart(2, '0');
    const d = String(local.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  function _addDays(str, days) {
    const base = parseDate(str);
    if (!base) return '';
    const dt = new Date(base.getFullYear(), base.getMonth(), base.getDate());
    dt.setDate(dt.getDate() + Number(days || 0));
    return formatDate(dt);
  }
  function nightsBetween(startStr, endStr) {
    const s = parseDate(startStr);
    const e = parseDate(endStr);
    if (!s || !e) return 0;
    const start = new Date(s.getFullYear(), s.getMonth(), s.getDate());
    const end = new Date(e.getFullYear(), e.getMonth(), e.getDate());
    return Math.max(0, Math.round((end - start) / (1000 * 60 * 60 * 24)));
  }

  // Estado do range do calendário (precisa estar antes de qualquer early return)
  const [dateRange, setDateRange] = useState([
    {
      startDate: parseDate(checkin) || new Date(),
      endDate: parseDate(checkout) || new Date(),
      key: 'selection',
    },
  ]);
  useEffect(()=>{ prevRangeRef.current = dateRange; }, [dateRange]);

  // Fechar popover clicando fora e reposicionar calendário em resize/scroll
  useEffect(() => {
    const onClickOutside = (e) => {
      if (showCalendar && calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
      if (showGuests && guestsRef.current && !guestsRef.current.contains(e.target) && !guestsAnchorRef.current?.contains(e.target)) {
        setShowGuests(false);
      }
    };
    const onReposition = () => {
      if (!showCalendar) return;
      try {
        const rect = anchorRef.current?.getBoundingClientRect();
        if (rect) {
          setPopoverPos({
            top: Math.round(rect.bottom + 10),
            right: Math.max(8, Math.round(window.innerWidth - rect.right)),
          });
        }
      } catch {
      // Ignore draft parsing errors
    }
    };
    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('touchstart', onClickOutside);
    window.addEventListener('resize', onReposition);
    window.addEventListener('scroll', onReposition, true);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('touchstart', onClickOutside);
      window.removeEventListener('resize', onReposition);
      window.removeEventListener('scroll', onReposition, true);
    };
  }, [showCalendar, showGuests]);

  // Mantém scroll da página; bloqueio é feito apenas via onWheel do dropdown

  // Montar reservas a partir do endpoint de disponibilidade
  useEffect(() => {
    const list = Array.isArray(availability) ? availability : [];
    const ranges = [];
    list.forEach(r => {
      const checkin = r.checkin || r.de || r.deRESERVA;
      const checkout = r.checkout || r.ate || r.ateRESERVA;
      if (!checkin || !checkout) return;
      const sd = parseDate(String(checkin));
      const ed = parseDate(String(checkout));
      if (!sd || !ed) return;
      // Usa componentes locais diretamente (datas sem hora, sem conversão de fuso)
      const sLocal = new Date(sd.getFullYear(), sd.getMonth(), sd.getDate());
      const eLocal = new Date(ed.getFullYear(), ed.getMonth(), ed.getDate());
      const status = r.status || (String(checkout).localeCompare(String(checkin)) ? 'booked' : 'booked');
      ranges.push({ start: sLocal, end: eLocal, status });
    });
    setReservedRanges(ranges);
    // Expand dates para disabledDates (DateRange) em HORÁRIO LOCAL (checkout livre:
    // bloqueia apenas as noites ocupadas [checkin, checkout), o dia do checkout
    // fica disponível para check-in da próxima reserva)
    const keys = new Set();
    ranges.forEach(({ start, end }) => {
      const sL = new Date(start.getFullYear(), start.getMonth(), start.getDate());
      const eL = new Date(end.getFullYear(), end.getMonth(), end.getDate());
      for (let dt = new Date(sL); dt < eL; dt.setDate(dt.getDate() + 1)) {
        const y = dt.getFullYear();
        const m = String(dt.getMonth()+1).padStart(2,'0');
        const d = String(dt.getDate()).padStart(2,'0');
        keys.add(`${y}-${m}-${d}`);
      }
    });
    setDisabledKeys(keys);
    // Converte keys para Date locais (necessário para DateRange.disabledDates)
    const days = Array.from(keys).map(k => {
      const [y, m, d] = k.split('-').map(Number);
      return new Date(y, (m || 1) - 1, d || 1);
    });
    setDisabledDates(days);
  }, [availability]);

  const scrollToMessage = () => {
    try {
      messageRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      messageRef.current?.focus();
    } catch {
      // Ignore draft parsing errors
    }
  };

  const openWhatsApp = () => {
    const raw = propertyData?.host?.whatsapp || propertyData?.proprietario?.whatsapp || propertyData?.whatsapp || '';
    const digits = String(raw).replace(/\D+/g, '');
    const msg = `Olá ${hostName}, tenho interesse em ${titulo}.`;
    const url = digits
      ? `https://wa.me/${digits}?text=${encodeURIComponent(msg)}`
      : `https://wa.me/?text=${encodeURIComponent(msg + ' ' + window.location.href)}`;
    try { window.open(url, '_blank', 'noopener'); } catch {
      // Ignore open errors
    }
  };

  // Mini form no canto inferior direito (estilo widget) para captura de lead quando não logado
  const showLeadCaptureWidget = (channel = 'whatsapp') => {
    return new Promise((resolve) => {
      try {
        // Carrega valores anteriores, se existirem
        let defaults = {};
        try { defaults = JSON.parse(localStorage.getItem('lead_contact_defaults') || '{}') || {}; } catch {
          // Ignore JSON parse errors
        }
        const root = document.createElement('div');
        root.style.position = 'fixed';
        root.style.right = '16px';
        root.style.bottom = '16px';
        root.style.zIndex = '2147483647';
        root.setAttribute('aria-live', 'polite');

        const headerText = (
          channel === 'call' ? 'Informe seus dados. Caso a ligação caia ou não complete, retornaremos para você.' :
          channel === 'email' ? 'Preencha seus dados para iniciar o contato por e-mail' :
          channel === 'site' ? 'Preencha seus dados para continuar no site da imobiliária' :
          channel === 'instagram' ? 'Preencha seus dados para continuar no Instagram' :
          channel === 'facebook' ? 'Preencha seus dados para continuar no Facebook' :
          'Olá! Preencha os campos abaixo para iniciar a conversa no WhatsApp'
        );
        const ctaText = (
          channel === 'call' ? 'INICIAR A LIGAÇÃO' :
          channel === 'email' ? 'ABRIR O E-MAIL' :
          'INICIAR A CONVERSA'
        );

        root.innerHTML = `
          <div style="width:360px; max-width:95vw; background:#fff; border-radius:8px; box-shadow:0 20px 40px rgba(0,0,0,.25); overflow:hidden; border:1px solid #e5e7eb; font-family:inherit;">
            <div style="background:#1f6f57; color:#fff; padding:10px 12px; display:flex; align-items:center; justify-content:space-between;">
              <div style="font-weight:700;">${headerText}</div>
              <button id="lc-close" aria-label="Fechar" style="background:transparent;border:0;color:#fff;font-size:18px;line-height:1;cursor:pointer">×</button>
            </div>
            <div style="padding:12px;">
              <div style="display:grid; gap:8px;">
                <input id="lc-nome" class="lc-input" placeholder="Nome *" style="padding:10px;border:1px solid #d1d5db;border-radius:6px;" />
                <input id="lc-email" type="email" class="lc-input" placeholder="Email *" style="padding:10px;border:1px solid #d1d5db;border-radius:6px;" />
                <input id="lc-telefone" class="lc-input" placeholder="Telefone (com código do país, ex: +1 555...)" style="padding:10px;border:1px solid #d1d5db;border-radius:6px;" />
                <button id="lc-submit" style="padding:12px 14px; background:#37a151; color:#fff; border:0; border-radius:6px; font-weight:800; letter-spacing:.3px; cursor:pointer;">${ctaText}</button>
              </div>
            </div>
          </div>`;

        const close = () => { try { document.body.removeChild(root); } catch {
          // Ignore remove errors
        } };
        root.querySelector('#lc-close')?.addEventListener('click', () => { close(); resolve(null); });

        // Prefill inputs com defaults
        try {
          const n = root.querySelector('#lc-nome'); if (n && defaults.nome) n.value = defaults.nome;
          const e = root.querySelector('#lc-email'); if (e && defaults.email) e.value = defaults.email;
          const t = root.querySelector('#lc-telefone'); if (t && defaults.telefone) t.value = defaults.telefone;
        } catch {
      // Ignore draft parsing errors
    }

        root.querySelector('#lc-submit')?.addEventListener('click', () => {
          const nome = root.querySelector('#lc-nome')?.value?.trim();
          const email = root.querySelector('#lc-email')?.value?.trim();
          let telefone = root.querySelector('#lc-telefone')?.value?.trim();
          if (!nome || !email) {
            // feedback simples
            const btn = root.querySelector('#lc-submit');
            if (btn) { btn.textContent = 'Preencha nome e e-mail'; btn.style.background = '#b91c1c'; setTimeout(()=>{ btn.textContent = ctaText; btn.style.background = '#37a151'; }, 1400); }
            return;
          }
          // Não força +55; aceita qualquer formatação. Se quiser, podemos normalizar apenas removendo espaços
          if (telefone) telefone = telefone.replace(/\s+/g, ' ').trim();
          // Persiste para reuso em outros imóveis
          try { localStorage.setItem('lead_contact_defaults', JSON.stringify({ nome, email, telefone })); } catch {
          // Ignore localStorage errors
        }
          close();
          resolve({ nome, email, telefone });
        });
        document.body.appendChild(root);
      } catch { resolve(null); }
    });
  };

  // Lead check/criação antes de abrir canais externos (WhatsApp, Email, Telefone, Site, Social)
  const postLead = async (lead, channel = 'whatsapp') => {
    const imovelId = Number(propertyData?.codigoIMOVEL) || 0;
    const token = localStorage.getItem('auth_token');
    try {
      await fetch(`${import.meta.env.VITE_URL_API}/leads/check`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          nome: lead.nome || '',
          email: lead.email || '',
          telefone: lead.telefone || '',
          origem: 'portal',
          metadata: { campanha: 'padrão', canal: channel },
          imovel: imovelId,
        })
      });
    } catch {
      // Não bloqueia a navegação se o lead falhar
    }
  };

  // Lead check/criação antes de abrir canais externos (WhatsApp, Site, Social)
  const ensureLeadAndThen = async (go, channel = 'whatsapp') => {
    const safeCall = () => { try { go(); } catch {
      // Ignore errors
    } };

    if (isLoggedIn && currentUser) {
      const nm = currentUser?.nome || currentUser?.name || currentUser?.nomeUSUARIO || '';
      const em = currentUser?.email || currentUser?.emailUSUARIO || '';
      const ph = currentUser?.telefone || currentUser?.phone || currentUser?.telefoneUSUARIO || currentUser?.celular || '';
      await postLead({ nome: nm, email: em, telefone: ph }, channel);
      safeCall();
      return;
    }

    // Usuário não logado: mini form estilo widget no canto inferior direito
    const value = await showLeadCaptureWidget(channel);
    if (value) {
      await postLead(value, channel);
    }
    // Mesmo que o usuário feche/cancele, ainda assim abrimos o canal solicitado
    safeCall();
  };

  const fireCall = () => {
    const phone = hostPhone;
    if (!phone) return;
    openTel(phone);
    if (isLoggedIn && currentUser) {
      const nm = currentUser?.nome || currentUser?.name || currentUser?.nomeUSUARIO || '';
      const em = currentUser?.email || currentUser?.emailUSUARIO || '';
      const ph = currentUser?.telefone || currentUser?.phone || currentUser?.telefoneUSUARIO || currentUser?.celular || phone;
      postLead({ nome: nm, email: em, telefone: ph }, 'call');
    } else {
      try {
        const defaults = JSON.parse(localStorage.getItem('lead_contact_defaults') || '{}');
        postLead({ nome: defaults.nome || '', email: defaults.email || '', telefone: defaults.telefone || phone }, 'call');
      } catch { postLead({ nome: '', email: '', telefone: phone }, 'call'); }
    }
  };

  const fireEmail = () => {
    const email = hostEmail;
    if (!email) return;
    openMail(email);
    if (isLoggedIn && currentUser) {
      const nm = currentUser?.nome || currentUser?.name || currentUser?.nomeUSUARIO || '';
      const em = currentUser?.email || currentUser?.emailUSUARIO || email;
      const ph = currentUser?.telefone || currentUser?.phone || currentUser?.telefoneUSUARIO || currentUser?.celular || '';
      postLead({ nome: nm, email: em, telefone: ph }, 'email');
    } else {
      try {
        const defaults = JSON.parse(localStorage.getItem('lead_contact_defaults') || '{}');
        postLead({ nome: defaults.nome || '', email: defaults.email || email, telefone: defaults.telefone || '' }, 'email');
      } catch { postLead({ nome: '', email, telefone: '' }, 'email'); }
    }
  };

  // Abre o modal de contato (ou login, se necessário)
  const openContactModal = () => {
    if (!isLoggedIn || !currentUser) {
      try {
        localStorage.setItem('post_login_redirect', window.location.pathname + window.location.search);
      } catch {
      // Ignore draft parsing errors
    }
      // Alerta amigável antes de abrir o login/cadastro
      try {
        return Swal.fire({
          icon: 'info',
          title: 'Entre ou cadastre-se',
          text: 'Para enviar uma mensagem ao anfitrião, você precisa estar logado. Faça login ou cadastre-se para continuar.',
          confirmButtonText: 'Entrar ou cadastrar-se',
          showCancelButton: true,
          cancelButtonText: 'Agora não',
        }).then((r)=>{
          if (r.isConfirmed) {
          try { handleOpenLogin(); } catch {
      // Ignore login errors
    }
          }
        });
      } catch {
      // Ignore draft parsing errors
    }
      return;
    }
    // Garante pré-preenchimento imediato ao abrir
    try {
      const nm = currentUser?.nome || currentUser?.name || currentUser?.nomeUSUARIO || '';
      const em = currentUser?.email || currentUser?.emailUSUARIO || '';
      const ph = currentUser?.telefone || currentUser?.phone || currentUser?.telefoneUSUARIO || currentUser?.celular || '';
      if (nm) setContactName(nm);
      if (em) setContactEmail(em);
      if (ph) setContactPhone(ph);
    } catch {
      // Ignore draft parsing errors
    }
    setIsContactModalOpen(true);
    setTimeout(() => {
      try { scrollToMessage(); } catch {
        // Ignore scroll errors
      }
    }, 0);
  };

  // Envia o formulário de contato ao anfitrião via sistema de chat
  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactError('');
    setContactSuccess('');
    setContactLoading(true);
    try {
      // Validações simples
      if (!contactName || !contactEmail || !contactText) {
        setContactError('Preencha nome, e-mail e mensagem.');
        setContactLoading(false);
        return;
      }

      const token = localStorage.getItem('auth_token');
      const imovelId = Number(propertyData?.codigoIMOVEL) || 0;

      // Usa o sistema de chat moderno (/chat/messages) para que a mensagem
      // apareça no dashboard "Mensagens" do anfitrião.
      // O backend cria a conversa automaticamente se ainda não existir.
      const chatPayload = {
        imovelId,
        content: contactText,
      };

      const res = await fetch(`${import.meta.env.VITE_URL_API}/chat/messages`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(chatPayload),
      });

      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || 'Erro ao enviar mensagem');
      }

      setContactSuccess('Mensagem enviada com sucesso!');
      try { Swal.fire({ icon: 'success', title: 'Enviado', text: 'A Sua mensagem foi enviada ao anfitrião.' }); } catch {
        // Ignore Swal errors
      }
      setIsContactModalOpen(false);
      setContactText('');
    } catch (err) {
      setContactError('Não foi possível enviar. Tente novamente.');
    } finally {
      setContactLoading(false);
    }
  };

  useEffect(() => {
    if (!propertyData) return;

    // Fetch all properties and filter similar ones
    const token = localStorage.getItem('auth_token');
    const headers = {
      accept: 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    };
    const categoriaId = propertyData?.categoriaIMOVEL ?? propertyData?.categoria?.codigoCATEGORIA;
    const url = categoriaId
      ? `${import.meta.env.VITE_URL_API}/imoveis?categoria=${encodeURIComponent(categoriaId)}`
      : `${import.meta.env.VITE_URL_API}/imoveis`;
    fetch(url, { headers })
      .then(async res => {
        if (!res.ok) {
          const text = await res.text();
          console.error('Falha ao buscar lista de imóveis', { status: res.status, url, text });
          throw new Error('Erro ao buscar imóveis');
        }
        return res.json();
      })
      .then(data => {
        console.log('Todos os imóveis retornados da API:', data); // Debug
        // A API pode retornar lista paginada no formato { data: [], pagination: {} }
        const list = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);
        const currId = propertyData?.codigoIMOVEL ?? propertyData?.id ?? propertyData?.codigo;
        const similares = list.filter((p) => {
          const pid = p?.codigoIMOVEL ?? p?.id ?? p?.codigo;
          return pid !== currId;
        }).slice(0, 10);
        setSimilarProperties(similares);
      })
      .catch(err => {
        console.error('Erro ao carregar imóveis similares:', err); // Debug
      });
  }, [propertyData]);

  if (loading) return <div className="property-loading">Carregando dados do imóvel...</div>;
  if (error) return <div className="property-error">{error}</div>;
  // Fallback adicional: se por algum motivo não houver dados, mostra mensagem amigável
  if (!propertyData) {
    return (
      <div className="property-error" style={{padding: '40px 16px', maxWidth: 960, margin: '0 auto'}}>
        Imóvel não encontrado ou indisponível no momento.
      </div>
    );
  }

  const handleShowAllPhotos = (index) => {
    setCurrentPhotoIndex(index);
    setIsPhotoViewerOpen(true);
  };

  const handleShare = () => {
    setIsShareModalOpen(true);
  };

  // Util para absolutizar URLs de mídia (igual Category)
  const absolutize = (src) => {
    if (!src || typeof src !== 'string') return '';
    if (src.startsWith('http') || src.startsWith('data:')) return src;
    const cleaned = src.replace(/^\.*\/+/, '').replace(/^images\//, 'images/');
    const host = (import.meta.env.VITE_PUBLIC_ASSETS_HOST || '').replace(/\/$/, '');
    const base = host || String(import.meta.env.VITE_URL_API || '').replace(/\/api\/?$/, '');
    return `${base}/${cleaned}`;
  };

  // Preview de fotos (lightbox simples)
  const handleViewPhotos = (property) => {
    try {
      let raw = [];
      if (Array.isArray(property.fotos) && property.fotos.length) raw = property.fotos;
      else if (Array.isArray(property.imagens) && property.imagens.length) raw = property.imagens;
      const imgs = raw
        .map(x => (typeof x === 'string' ? absolutize(x) : absolutize(x?.urlFOTO || x?.pathFOTO || '')))
        .filter(Boolean);
      if (!imgs.length) return;
      let idx = 0;
      const renderHtml = (src, index, total) => `
        <div style="position:relative; display:flex; align-items:center; justify-content:center; background:rgba(0,0,0,0.9); padding:16px; margin:0;">
          <button id="lb-prev" style="position:absolute; left:24px; top:50%; transform:translateY(-50%); z-index:10; border:none; background:rgba(0,0,0,0.6); color:#fff; width:42px; height:42px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer; font-size:20px;">❮</button>
          <div style="background:#000; padding:8px; border-radius:6px; box-shadow:0 20px 40px rgba(0,0,0,0.35);">
            <img id="lb-img" src="${src}" style="max-width:94vw; max-height:80vh; object-fit:contain; border-radius:6px; display:block;" />
          </div>
          <button id="lb-next" style="position:absolute; right:24px; top:50%; transform:translateY(-50%); z-index:10; border:none; background:rgba(0,0,0,0.6); color:#fff; width:42px; height:42px; border-radius:50%; display:flex; align-items:center; justify-content:center; cursor:pointer; font-size:20px;">❯</button>
          <div id="lb-counter" style="position:absolute; bottom:18px; left:50%; transform:translateX(-50%); background:rgba(0,0,0,.7); color:#fff; padding:6px 12px; border-radius:12px; font-weight:700;">${index+1} / ${total}</div>
        </div>`;
      const update = (swalContent) => {
        const img = swalContent.querySelector('#lb-img');
        const counter = swalContent.querySelector('#lb-counter');
        if (img) img.src = imgs[idx];
        if (counter) counter.textContent = `${idx + 1} / ${imgs.length}`;
      };

      const styleId = 'lb-style';
      const style = document.getElementById(styleId) || document.createElement('style');
      style.id = styleId;
      style.innerHTML = `
        .swal2-container.lb-container { padding: 0 !important; align-items: center !important; justify-content: center !important; background: rgba(0,0,0,0.95) !important; z-index: 2147483647 !important; }
        .swal2-container.lb-container.swal2-backdrop-show, .swal2-container.lb-container.swal2-shown { background: rgba(0,0,0,0.95) !important; }
        .swal2-popup.lb-popup { background: transparent !important; box-shadow: none !important; padding: 0 !important; max-width: 98vw !important; }
        .swal2-html-container { margin: 0 !important; padding: 0 !important; }
        .lb-close { color: #fff !important; font-size: 22px !important; }
        .lb-close:hover { color: #f3f4f6 !important; }
      `;
      if (!style.parentNode) document.head.appendChild(style);

      Swal.fire({
        html: renderHtml(imgs[idx], idx, imgs.length),
        width: '98vw', padding: 0, background: 'transparent',
        backdrop: 'rgba(0, 0, 0, 0.95)',
        heightAuto: false,
        customClass: { container: 'lb-container', popup: 'lb-popup', closeButton: 'lb-close' },
        showConfirmButton: false, showCloseButton: true, allowOutsideClick: false,
        didOpen: (el) => {
          const popup = Swal.getPopup?.();
          const container = Swal.getContainer?.();
          if (container) {
            container.style.padding = '0';
            container.style.alignItems = 'center';
            container.style.backdropFilter = 'blur(1px)';
            container.style.zIndex = '20000';
            container.style.height = '100vh';
          }
          if (popup) {
            popup.style.background = 'transparent';
            popup.style.boxShadow = 'none';
            popup.style.padding = '0';
            popup.style.maxWidth = '98vw';
            popup.style.margin = '0 auto';
          }
          if (document?.body) {
            document.body.dataset.lbScroll = document.body.style.overflow || '';
            document.body.style.overflow = 'hidden';
          }
          const closeBtn = popup?.querySelector('.swal2-close');
          if (closeBtn) {
            closeBtn.style.color = '#fff';
            closeBtn.style.right = '12px';
            closeBtn.style.top = '12px';
            closeBtn.style.outline = 'none';
            closeBtn.style.textShadow = '0 2px 6px rgba(0,0,0,0.5)';
          }
          const prev = el.querySelector('#lb-prev');
          const next = el.querySelector('#lb-next');
          const onPrev = () => { idx = (idx - 1 + imgs.length) % imgs.length; update(el); };
          const onNext = () => { idx = (idx + 1) % imgs.length; update(el); };
          prev?.addEventListener('click', onPrev);
          next?.addEventListener('click', onNext);
        },
        willClose: () => {
          if (document?.body) {
            document.body.style.overflow = document.body.dataset.lbScroll || '';
            delete document.body.dataset.lbScroll;
          }
        }
      });
    } catch {
      // Ignore lightbox errors
    }
  };

  // Preview de vídeo (iframe embed, igual Category)
  const handleViewVideo = (property) => {
    let raw = String(property?.videoIMOVEL || '').trim();
    if (!raw) { try { Swal.fire({ toast: true, position: 'top-end', timer: 2000, showConfirmButton: false, icon: 'info', title: 'Imóvel sem vídeo' }); } catch {
      // Ignore Swal errors
    } return; }
    const hasIframe = /<\s*iframe[\s\S]*><\s*\/\s*iframe\s*>/i.test(raw) || /<\s*iframe[^>]*>/i.test(raw);
    const toEmbed = (url) => {
      try {
        const u = new URL(url);
        const host = u.hostname.replace(/^www\./, '');
        if (host.includes('youtube.com')) {
          const v = u.searchParams.get('v');
          let id = v;
          if (!id && u.pathname.startsWith('/shorts/')) id = u.pathname.split('/shorts/')[1]?.split(/[?&#]/)[0];
          if (!id && u.pathname.startsWith('/embed/')) id = u.pathname.split('/embed/')[1]?.split(/[?&#]/)[0];
          if (!id && u.pathname.startsWith('/watch')) id = v;
          if (id) return `https://www.youtube.com/embed/${id}`;
          return url;
        }
        if (host.includes('youtu.be')) {
          const id = u.pathname.slice(1).split(/[?&#]/)[0];
          if (id) return `https://www.youtube.com/embed/${id}`;
          return url;
        }
        if (host.includes('vimeo.com')) {
          const id = u.pathname.replace(/\/(video|channels|ondemand)/, '').split('/').filter(Boolean)[0];
          if (id) return `https://player.vimeo.com/video/${id}`;
          return url;
        }
      } catch {
      // Ignore draft parsing errors
    }
      return url;
    };
    let contentHtml = '';
    if (hasIframe) {
      contentHtml = `<div style="position:relative;padding-top:56.25%;width:100%;">${raw}</div>`;
    } else {
      const embedSrc = toEmbed(raw);
      contentHtml = `
        <div style="position:relative;padding-top:56.25%;width:100%;">
          <iframe src="${embedSrc}" style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
        </div>`;
    }
    Swal.fire({ title: 'Vídeo do imóvel', html: `<div style="padding:0;position:relative;">${contentHtml}</div>`, width: '80%', padding: 0, background: '#000', showConfirmButton: false, showCloseButton: true });
  };

  // Comparar (usa localStorage)
  const handleCompare = (property) => {
    const mapped = {
      id: property?.codigoIMOVEL || property?.id,
      tituloIMOVEL: property?.tituloIMOVEL,
      enderecoIMOVEL: property?.enderecoIMOVEL,
      valorIMOVEL: property?.valorIMOVEL,
      quartosIMOVEL: property?.quartosIMOVEL,
      banheirosIMOVEL: property?.banheirosIMOVEL,
      metragemIMOVEL: property?.metragemIMOVEL,
      vagasgaragemIMOVEL: property?.vagasgaragemIMOVEL,
      fotos: property?.fotos,
    };
    try {
      const prev = JSON.parse(localStorage.getItem('compare_items') || '[]');
      const exists = prev.some(p => String(p.id) === String(mapped.id));
      const next = exists ? prev : [...prev, mapped];
      localStorage.setItem('compare_items', JSON.stringify(next));
      try { Swal.fire({ toast: true, position: 'top-end', timer: 1800, showConfirmButton: false, icon: 'success', title: 'Adicionado à comparação' }); } catch {
        // Ignore Swal errors
      }
    } catch {
      // Ignore lightbox errors
    }
  };

  const sliderSettings = { // eslint-disable-line no-unused-vars
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  const caracteristicas = propertyData || {};

  const areaUnit = (() => {
    const raw = propertyData?.tipometragemIMOVEL
      ?? propertyData?.tipoMetragemIMOVEL
      ?? propertyData?.tipoMetragem;
    const str = String(raw || '').toLowerCase();
    if (raw === 2 || raw === '2' || str.includes('ft')) return 'ft²';
    if (raw === 1 || raw === '1' || str.includes('m')) return 'm²';
    return 'm²';
  })();

  const areaLabel = areaUnit === 'ft²' ? 'Área (ft²)' : 'Área (m²)';

  const caracteristicasMap = [
    { key: 'qtdpessoasIMOVEL', label: 'Pessoas', icon: <FaUser /> },
    { key: 'solteirocamasIMOVEL', label: 'Cama de Solteiro', pluralLabel: 'Camas de Solteiro', icon: <FaBed />, pluralize: true },
    { key: 'casalcamasIMOVEL', label: 'Cama de Casal', pluralLabel: 'Camas de Casal', icon: <FaBed />, pluralize: true },
    { key: 'casadebanhoIMOVEL', label: 'Casa de Banho', pluralLabel: 'Casas de Banho', icon: <FaBath />, pluralize: true },
    { key: 'lavanderiaIMOVEL', label: 'Lavanderia', icon: <FaShower />, boolean: true },
    { key: 'wifiIMOVEL', label: 'Wi-Fi', icon: <FaWifi />, boolean: true },
    { key: 'closetIMOVEL', label: 'Closet', icon: <FaDoorOpen />, boolean: true },
    { key: 'arcondicionadoIMOVEL', label: 'Ar Condicionado', icon: <FaSnowflake />, boolean: true },
    { key: 'quartosIMOVEL', label: 'Quarto', pluralLabel: 'Quartos', icon: <FaBed />, pluralize: true },
    { key: 'vagasgaragemIMOVEL', label: 'Vaga de Garagem', pluralLabel: 'Vagas de Garagem', icon: <FaParking />, pluralize: true },
    { key: 'salaodejogosIMOVEL', label: 'Salão de Jogos', icon: <FaGamepad />, boolean: true },
    { key: 'portariaIMOVEL', label: 'Portaria', icon: <FaDoorClosed />, boolean: true },
    { key: 'playgroundIMOVEL', label: 'Playground', icon: <FaChild />, boolean: true },
    { key: 'proximoaometroIMOVEL', label: 'Próximo ao Metrô', icon: <FaSubway />, boolean: true },
    { key: 'elevadorIMOVEL', label: 'Elevador', icon: <FaArrowUp />, boolean: true },
    { key: 'poraoIMOVEL', label: 'Porão', icon: <FaWarehouse />, boolean: true },
    { key: 'quadraesportivaIMOVEL', label: 'Quadra Esportiva', icon: <FaFutbol />, boolean: true },
    { key: 'festaIMOVEL', label: 'Festas', icon: <FaGlassCheers />, boolean: true },
    { key: 'academiaIMOVEL', label: 'Academia', icon: <FaDumbbell />, boolean: true },
    { key: 'saunaIMOVEL', label: 'Sauna', icon: <FaHotTub />, boolean: true },
    { key: 'petsIMOVEL', label: 'Pets', icon: <FaPaw />, boolean: true },
    { key: 'coberturaIMOVEL', label: 'Cobertura', icon: <FaBuilding />, boolean: true },
    { key: 'adegaIMOVEL', label: 'Adega', icon: <FaWineBottle />, boolean: true },
    { key: 'metragemIMOVEL', label: areaLabel, icon: <FaRuler /> },
    // ...adicione mais conforme necessário
  ];

  // Check-in/out e estadia mínima/máxima vindos da API
  const checkinTime = propertyData?.checkinIMOVEL || '15:00:00';
  const checkoutTime = propertyData?.checkoutIMOVEL || '11:00:00';
  const minNights = Number(propertyData?.permanenciaminimaIMOVEL ?? 1);
  const maxNights = Number(propertyData?.permanenciamaximaIMOVEL ?? 30);
  

  // Midia (vídeo e 360) vindos da API — suportar URL ou HTML <iframe>
  const rawVideoField = propertyData?.midia?.videoIMOVEL || propertyData?.videoIMOVEL || '';
  const rawTourField = propertyData?.midia?.["360IMOVEL"] || propertyData?.["360IMOVEL"] || '';

  // Sanitização muito básica: remove tags <script>...
  const sanitize = (html) => String(html || '').replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');

  const hasIframeVideo = /<iframe[\s\S]*?>/i.test(String(rawVideoField || ''));
  const hasIframeTour = /<iframe[\s\S]*?>/i.test(String(rawTourField || ''));

  const videoUrl = (() => {
    if (hasIframeVideo) return '';
    const url = String(rawVideoField || '').trim();
    if (!url) return '';
    // Converte URL do YouTube para embed se necessário
    try {
      if (url.includes('youtube.com/watch') || url.includes('youtu.be/')) {
        const u = new URL(url);
        let id = '';
        if (u.hostname.includes('youtu.be')) {
          id = u.pathname.replace('/', '');
        } else {
          id = u.searchParams.get('v') || '';
        }
        return id ? `https://www.youtube.com/embed/${id}` : url;
      }
    } catch {
      // Ignore draft parsing errors
    }
    return url;
  })();

  const tour3DUrl = hasIframeTour ? '' : String(rawTourField || '').trim();

  return (
    <>
      <div className="property-page">
        <div className="property-gallery">
        {/* Imagem principal grande */}
        <div
          className="main-image"
          onClick={() => handleShowAllPhotos(0)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleShowAllPhotos(0);
            }
          }}
        >
          <img src={fotos[0]} alt="Vista principal da propriedade" />
        </div>
        {/* Grid de imagens menores */}
        <div className="image-grid">
          {fotos.slice(1).map((image, index) => (
            <div key={index} className="grid-image">
              <img src={image} alt={`Vista ${index + 2} da propriedade`} />
              {index === 1 && (
                <button className="view-all-photos" onClick={() => handleShowAllPhotos(0)}>
                  <FaImages />
                  Ver todas as fotos
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
      {/* Barra de título do imóvel */}
      <div className="property-title-bar">
        <div className="title-content">
          <div className="title-left">
            <div className="title-actions">
              <button className="back-button" onClick={() => window.history.back()}>
                <FaArrowLeft />
                VOLTAR
              </button>
              <div className="title-badges">
                {tipoImovelChip && <span className="badge type-imovel">{tipoImovelChip}</span>}
                {isAfiliado && (
                  <span
                    className="badge"
                    title={`Anúncio importado — reserva e contato no ${afiliacaoNome}`}
                    style={{ background: '#fef3c7', color: '#92400e', border: '1px solid #fbbf24' }}
                  >
                    {afiliacaoNome.toUpperCase()}
                  </span>
                )}
                <span className="badge highlight">DESTAQUE</span>
                {/* Exibe visualizações somente se houver valor; badges inertes removidas */}
                {(() => {
                  const views = propertyData?.metricas?.visualizacoes || propertyData?.visualizacoesIMOVEL;
                  return (typeof views === 'number' && !Number.isNaN(views)) ? (
                    <span className="badge views">{views}</span>
                  ) : null;
                })()}
              </div>
            </div>
            <h1>{titulo}</h1>
            <div className="property-location">
              <FaMapMarkerAlt />
              <span>{propertyData?.cidadeIMOVEL || propertyData?.enderecoIMOVEL || 'Localização não disponível'}</span>
            </div>
          </div>
          <div className="title-right">
            <div className="title-buttons">
              <button 
                className="favorite-button"
                onClick={() => {
                  if (isFavorited(propertyData?.codigoIMOVEL)) {
                    handleUnfavorite(propertyData?.codigoIMOVEL);
                  } else {
                    handleFavorite(propertyData?.codigoIMOVEL);
                  }
                }}
                style={{ color: isFavorited(propertyData?.codigoIMOVEL) ? '#BA824F' : undefined }}
              >
                <FaHeart style={{ fill: isFavorited(propertyData?.codigoIMOVEL) ? '#BA824F' : 'none', stroke: '#BA824F', strokeWidth: 40 }} />
                {isFavorited(propertyData?.codigoIMOVEL) ? 'Remover dos Favoritos' : 'Favorito'}
              </button>
              <button className="share-button" onClick={handleShare}>
                <FaShare />
                Compartilhar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="property-content">
        <div className="property-main">
          {/* Seção de Características */}
          <section className="caracteristicas-section">
            <h2 className="section-title">Características</h2>
            <div className="facts-grid">
              {caracteristicasMap.map(({ key, label, pluralLabel, icon, pluralize, boolean }) => {
                const valor = caracteristicas[key];
                if (valor === undefined || valor === null || valor === '') {
                  return (
                    <div className="fact-item" key={key}>
                      <span className="fact-icon">{icon}</span>
                      <div>
                        <div className="fact-label">{label}</div>
                        <div className="fact-value">Não informado</div>
                      </div>
                    </div>
                  );
                }
                const num = Number(valor);
                let display;
                if (boolean) {
                  display = num ? 'Sim' : 'Não';
                } else if (key === 'metragemIMOVEL') {
                  display = `${num} ${areaUnit}`;
                } else {
                  display = num;
                }
                const finalLabel = pluralize && num > 1 ? (pluralLabel || `${label}s`) : label;
                return (
                  <div className="fact-item" key={key}>
                    <span className="fact-icon">{icon}</span>
                    <div>
                      <div className="fact-label">{finalLabel}</div>
                      <div className="fact-value">{display}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* Seção de Limpeza e Taxa de Turismo (apenas para férias) */}
          {tipoImovelChip === 'FÉRIAS' && (
            <section className="caracteristicas-section" style={{ marginTop: '32px' }}>
              <h2 className="section-title">Informações Adicionais</h2>
              <div className="details-grid">
                {/* Limpeza */}
                <div className="detail-item" style={{ gridColumn: '1 / -1' }}>
                  <div className="detail-info">
                    <span className="detail-label">Limpeza</span>
                    <span className="detail-value">
                      {toBoolean(propertyData?.limpezaCobrada) ? `Taxa de limpeza: €${propertyData?.valorLimpeza || '0'}` : 'A limpeza do imóvel é gratuita'}
                    </span>
                  </div>
                </div>
                {/* Taxa de Turismo */}
                <div className="detail-item" style={{ gridColumn: '1 / -1' }}>
                  <div className="detail-info">
                    <span className="detail-label">Taxa de Turismo</span>
                    <span className="detail-value">
                      {toBoolean(propertyData?.taxaTurismoCobrada) ? (
                        <>
                          Adulto: €{propertyData?.valorTaxaTurismoAdulto || '0'}
                          <br />
                          Criança: €{propertyData?.valorTaxaTurismoCrianca || '0'}
                          <br />
                          Idade máxima da criança: {propertyData?.idadeMaximaCrianca || '17'} anos
                        </>
                      ) : 'Sem cobrança de taxa de turismo'}
                    </span>
                  </div>
                </div>
              </div>
            </section>
          )}

          
          {/* Seção de Descrição */}
          <section className="description-section">
            <h2 className="section-title">Descrição</h2>
            {(() => {
              const full = String(descricao || '');
              const limit = 320;
              const collapsed = full.length > limit ? (full.slice(0, limit).trimEnd() + '…') : full;
              const shouldCollapse = full.length > limit;
              return (
                <>
                  <p className="description-text" style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                    {descriptionExpanded ? full : collapsed}
                  </p>
                  {shouldCollapse && (
                    <button 
                      type="button" 
                      onClick={() => setDescriptionExpanded(prev => !prev)} 
                      className="show-more-button"
                    >
                      {descriptionExpanded ? 'Mostrar menos' : 'Mostrar tudo'}
                    </button>
                  )}
                </>
              );
            })()}
          </section>

          {regrasAdicionais?.trim() && (
            <section className="description-section">
              <h2 className="section-title">Regras Adicionais</h2>
              <p className="description-text" style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>
                {regrasAdicionais}
              </p>
            </section>
          )}

          {/* Seção de Detalhes Adicionais */}
          <section className="details-section">
            <h2 className="section-title">Detalhes Adicionais</h2>
            <div className="details-grid">
              <div className="detail-item">
                <FaMapMarkerAlt className="detail-icon" />
                <div className="detail-info">
                  <span className="detail-label">ID do imóvel</span>
                  <span className="detail-value">{propertyData?.idIMOVEL || propertyData?.codigoIMOVEL}</span>
                </div>
              </div>
              <div className="detail-item">
                <FaHome className="detail-icon" />
                <div className="detail-info">
                  <span className="detail-label">Tipo de propriedade</span>
                  <span className="detail-value">{tipoImovelNome}</span>
                </div>
              </div>
              {quartos > 0 && (
                <div className="detail-item">
                  <FaBed className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Quartos</span>
                    <span className="detail-value">{quartos}</span>
                  </div>
                </div>
              )}
              {propertyData?.solteirocamasIMOVEL > 0 && (
                <div className="detail-item">
                  <FaBed className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Camas de solteiro</span>
                    <span className="detail-value">{propertyData.solteirocamasIMOVEL}</span>
                  </div>
                </div>
              )}
              {propertyData?.casalcamasIMOVEL > 0 && (
                <div className="detail-item">
                  <FaBed className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Camas de casal</span>
                    <span className="detail-value">{propertyData.casalcamasIMOVEL}</span>
                  </div>
                </div>
              )}
              <div className="detail-item">
                <FaRuler className="detail-icon" />
                <div className="detail-info">
                  <span className="detail-label">Tamanho</span>
                  <span className="detail-value">{metragem ? `${metragem} ${areaUnit}` : '—'}</span>
                </div>
              </div>
              {banheiros > 0 && (
                <div className="detail-item">
                  <FaBath className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Casas de banho</span>
                    <span className="detail-value">{banheiros}</span>
                  </div>
                </div>
              )}
              {vagas > 0 && (
                <div className="detail-item">
                  <FaParking className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Garagem</span>
                    <span className="detail-value">{vagas}</span>
                  </div>
                </div>
              )}
              {propertyData?.adegaIMOVEL ? (
                <div className="detail-item">
                  <FaWineBottle className="detail-icon" />
                  <div className="detail-info">
                    <span className="detail-label">Adega</span>
                    <span className="detail-value">{propertyData?.adegaIMOVEL}</span>
                  </div>
                </div>
              ) : null}
            </div>
          </section>
          {/* Seção de Vídeo Informativo (condicional) */}
          {(hasIframeVideo || videoUrl) && (
            <section className="video-section">
              <h2 className="section-title">Vídeo Informativo</h2>
              <div className="video-container">
                {hasIframeVideo ? (
                  <div dangerouslySetInnerHTML={{ __html: sanitize(rawVideoField) }} />
                ) : (
                  <iframe 
                    width="100%" 
                    height="415" 
                    src={videoUrl} 
                    title="Vídeo do imóvel" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerPolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </section>
          )}
          {/* Seção de Tour Virtual 3D (condicional) */}
          {(hasIframeTour || tour3DUrl) && (
            <section className="tour-3d-section">
              <h2 className="section-title">Tour Virtual 3D</h2>
              <div className="tour-container">
                {hasIframeTour ? (
                  <div dangerouslySetInnerHTML={{ __html: sanitize(rawTourField) }} />
                ) : (
                  <iframe 
                    src={tour3DUrl} 
                    width="100%" 
                    height="430" 
                    allowFullScreen 
                    style={{ border: 0 }}
                  ></iframe>
                )}
              </div>
            </section>
          )}

          {/* Calendário de Disponibilidade — oculto em imóveis afiliados (disponibilidade vive na plataforma de origem) */}
          {showBookingAndCalendar && !isAfiliado && (
            <AvailabilityCalendar
              reservedRanges={reservedRanges}
              minNights={minNights}
              maxNights={maxNights}
              initialDate={new Date()}
              title="Disponibilidade"
              onRangeSelect={(start, end) => {
                if (!(start && end)) return;
                setCheckin(formatDate(start));
                setCheckout(formatDate(end));
                setDateRange([{ startDate: start, endDate: end, key: 'selection' }]);
                // abre o popover posicionado para revisar se quiser
                openCalendar();
              }}
            />
          )}

          {/* Seção de Localização */}
          <section className="location-section">
            <h2 className="section-title">Localização</h2>
            <div className="map-tabs">
              <button className="map-tab active">Mapa</button>
              <button className="map-tab">Satélite</button>
            </div>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4847274039365!2d-45.5944444!3d-22.7444444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDQ0JzQwLjAiUyA0NcKwMzUnNDAuMCJX!5e0!3m2!1spt-BR!2sbr!4v1625097752726!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </section>
        </div>
        <div className="host-card">
          <div className="price-per-night">
            {propertyData?.exibirPreco === false || propertyData?.exibirPreco === 0 || propertyData?.exibirPreco === '0' ? (
              <>
                <span className="price-value">Sob consulta</span>
                <span className="price-label">
                  Entre em contato com o proprietário para mais informações sobre o valor deste imóvel.
                </span>
              </>
            ) : (
              <>
                <span className="price-value">{Number(valor) ? formatPrice(valor, tipoImovel) : '—'}</span>
                <span className="price-label">
                  {(() => {
                    const t = Number(tipoImovel);
                    if (t === 1) return 'preço de venda';
                    if (t === 2) return 'preço de aluguel';
                    if (t === 3) return 'por noite';

                    // Fallback inteligente se o tipo estiver vindo errado do backend
                    const lbl = String(propertyData?.labelvalorIMOVEL || '').toLowerCase();
                    if (lbl.includes('feri') || lbl.includes('temporada')) return 'por noite';
                    if (lbl.includes('mes') || lbl.includes('mês')) return 'por mês';
                    if (lbl.includes('venda')) return 'preço de venda';

                    return '';
                  })()}
                </span>
              </>
            )}
          </div>
          {/* Imóvel afiliado: reserva/contato acontecem na plataforma de origem */}
          {isAfiliado && (
            <div style={{
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
              padding: 18,
              margin: '18px 0 12px 0',
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
            }}>
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#fef3c7', color: '#92400e', fontSize: 12, fontWeight: 700, borderRadius: 999, padding: '3px 10px', alignSelf: 'flex-start' }}>
                Anúncio · {afiliacaoNome}
              </span>
              <p style={{ margin: 0, fontSize: 13, color: '#4b5563', lineHeight: 1.5 }}>
                Este anúncio é gerido no {afiliacaoNome}. A reserva e o contato com o anfitrião são feitos diretamente na plataforma de origem.
              </p>
              <button
                type="button"
                onClick={openAfiliacao}
                style={{
                  background: '#ba824f',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 8,
                  fontWeight: 700,
                  fontSize: '1rem',
                  padding: '10px 0',
                  marginTop: 4,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 8,
                }}
              >
                Reservar no {afiliacaoNome} <FaExternalLinkAlt size={13} />
              </button>
            </div>
          )}
          {/* Formulário de Reserva Instantânea */}
          {showBookingAndCalendar && !isAfiliado && (
          <form className="instant-booking-form" style={{
            background: '#fff',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
            padding: 18,
            margin: '18px 0 12px 0',
            display: 'flex',
            flexDirection: 'column',
            gap: 10
          }} onSubmit={async e => {
            e.preventDefault();
            setBookingMsg('');
            if (!checkin || !checkout || (adults + childrenCount + babies + pets) === 0) {
              setBookingMsg('Preencha as datas e o número de hóspedes.');
              return;
            }
            // Exigir autenticação para solicitar reserva
            if (!isLoggedIn || !user) {
            try { handleOpenLogin(); } catch {
      // Ignore login errors
    }
              setBookingMsg('Faça login para solicitar a reserva.');
              return;
            }
            try {
              setBookingLoading(true);
              const token = localStorage.getItem('auth_token');
              const headers = {
                'Content-Type': 'application/json',
                accept: 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {})
              };
              if (!token) {
                setBookingMsg('Sessão expirada. Faça login novamente.');
              try { handleOpenLogin(); } catch {
      // Ignore login errors
    }
                setBookingLoading(false);
                return;
              }
              const usuario = user?.codigo || user?.id || user?.userId;
              const hostId = propertyData?.clienteIMOVEL || propertyData?.dadosBasicos?.clienteIMOVEL || propertyData?.host?.codigo || propertyData?.proprietario?.codigo || propertyData?.anunciante?.codigo || propertyData?.agente?.codigo || propertyData?.imobiliaria?.codigo;
              if (!hostId) console.warn('[Reserva] hostRESERVA não resolvido a partir dos dados do imóvel; será enviado 0');
              const nNoites = nightsBetween(checkin, checkout) || 1;
              const valorTotal = Number(valor) > 0 ? Number(valor) * nNoites : null;
              // Alinha com a API do backend: campos *_RESERVA
              const payload = {
                hostRESERVA: hostId || 0,
                usuarioRESERVA: usuario,
                deRESERVA: checkin,
                ateRESERVA: checkout,
                imovelRESERVA: propertyData?.codigoIMOVEL,
                statusRESERVA: 1, // pendente/solicitada
                statuspagamentoRESERVA: 1, // pendente
                noitesRESERVA: nNoites,
                valorRESERVA: valorTotal,
                slugRESERVA: nNoites, // usa nº de noites como slug simples
                ativoRESERVA: 1,
                // Campos auxiliares (não obrigatórios)
                hospedesRESERVA: JSON.stringify({ adultos: adults, criancas: childrenCount, bebes: babies, pets: pets }),
                observacaoRESERVA: guestMessage || '',
              };
              console.log('[Reserva] Enviando payload:', payload);
              const res = await fetch(`${import.meta.env.VITE_URL_API}/reservas`, {
                method: 'POST',
                headers,
                body: JSON.stringify(payload)
              });
              let data;
              try { data = await res.json(); } catch (_) { data = null; }
              console.log('[Reserva] Resposta do POST /reservas:', res.status, data);
              if (!res.ok || data?.success === false) {
                const msg = data?.message || 'Não foi possível enviar a reserva. Tente novamente.';
                setBookingMsg(msg);
              } else {
                setBookingMsg('Pedido de reserva enviado! Você receberá um retorno do anfitrião.');
                setCheckin(''); setCheckout(''); setGuests(1); setGuestMessage('');
                // Atualiza calendário com a nova reserva
                fetch(`${import.meta.env.VITE_URL_API}/imoveis/${id}/disponibilidade`, { headers })
                  .then(r => (r.ok ? r.json() : []))
                  .then(list => setAvailability(Array.isArray(list) ? list : []))
                  .catch(() => {});
              }
            } catch (err) {
              console.error('[Reserva] Falha ao enviar reserva:', err);
              setBookingMsg('Não foi possível enviar a reserva. Verifique sua conexão e tente novamente.');
            } finally {
              setBookingLoading(false);
            }
          }}>
            {/* Informações claras de horários e regras */}
            <div style={{ background:'#f9fafb', border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 10px', color:'#374151', fontSize:13 }}>
              <div><strong>Check-in:</strong> a partir das {checkinTime?.slice(0,5)} • <strong>Check-out:</strong> até {checkoutTime?.slice(0,5)}</div>
              <div style={{ marginTop:4 }}>
                <strong>Estadia:</strong> mínimo de {minNights} noite{minNights>1?'s':''}{maxNights?` • máximo de ${maxNights} noite${maxNights>1?'s':''}`:''}
              </div>
            </div>
            {/* Inputs estilo Airbnb + Popover Calendar */}
            <div ref={anchorRef} style={{ position: 'relative' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0, border: '1px solid #111', borderRadius: 12, overflow: 'hidden' }}>
                <button type="button" onClick={openCalendar} style={{ textAlign:'left', padding: '10px 12px', borderRight: '1px solid #ddd', background:'#fff' }}>
                  <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.04em', color:'#6b7280' }}>CHECK-IN</div>
                  <div style={{ fontWeight:800, color:'#111827' }}>{checkin ? parseDate(checkin)?.toLocaleDateString() : 'Selecionar'}</div>
                </button>
                <button type="button" onClick={openCalendar} style={{ textAlign:'left', padding: '10px 12px', background:'#fff' }}>
                  <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.04em', color:'#6b7280' }}>CHECKOUT</div>
                  <div style={{ fontWeight:800, color:'#111827' }}>{checkout ? parseDate(checkout)?.toLocaleDateString() : 'Selecionar'}</div>
                </button>
              </div>
              {showCalendar && createPortal(
                (
                  <div ref={calendarRef} style={{ position:'fixed', zIndex:10000, top: popoverPos.top, right: popoverPos.right, background:'#fff', border:'1px solid #e5e7eb', borderRadius:16, boxShadow:'0 12px 32px rgba(0,0,0,.2)', padding:12 }}>
                    <DateRange
                      onChange={({ selection }) => {
                        let start = selection.startDate || dateRange?.[0]?.startDate;
                        let end = selection.endDate;

                        // normaliza para meia-noite local
                        if (start) start = new Date(start.getFullYear(), start.getMonth(), start.getDate());
                        if (end) end = new Date(end.getFullYear(), end.getMonth(), end.getDate());

                        // Se não há end ainda, apenas define início e sai
                        if (start && !end) {
                          setDateRange([{ ...selection, startDate: start, endDate: null }]);
                          setCheckin(formatDate(start));
                          setCheckout('');
                          return;
                        }

                        if (start && end) {
                          // não permitir start/end em dia bloqueado
                          if (disabledKeys?.has?.(dateKey(start)) || disabledKeys?.has?.(dateKey(end))) {
                            return;
                          }
                          // não atravessar dia bloqueado
                          const forward = start <= end;
                          let cur = new Date(start);
                          while ((forward && cur < end) || (!forward && cur > end)) {
                            if (disabledKeys?.has?.(dateKey(cur))) return;
                            cur.setDate(cur.getDate() + (forward ? 1 : -1));
                          }
                          const n = Math.max(0, Math.round((end - start) / (1000*60*60*24)));
                          if (n < minNights) {
                            end = new Date(start);
                            end.setDate(end.getDate() + minNights);
                          } else if (maxNights && n > maxNights) {
                            end = new Date(start);
                            end.setDate(end.getDate() + maxNights);
                          }
                        }

                        const newSel = { ...selection, startDate: start, endDate: end };
                        setDateRange([newSel]);
                        setCheckin(formatDate(start));
                        setCheckout(formatDate(end));
                      }}
                      moveRangeOnFirstSelection={false}
                      ranges={dateRange}
                      months={2}
                      direction="horizontal"
                      minDate={new Date()}
                      disabledDates={disabledDates}
                      disabledDay={(date)=> disabledKeys?.has?.(dateKey(date))}
                    />
                    <div style={{ display:'flex', justifyContent:'space-between', marginTop:8 }}>
                      <button type="button" onClick={()=>{ setShowCalendar(false); }} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:10, background:'#f3f4f6', fontWeight:700 }}>Fechar</button>
                      <div style={{ color:'#6b7280', alignSelf:'center', fontSize:13 }}>{nightsBetween(checkin, checkout)} noite(s)</div>
                    </div>
                  </div>
                ),
                document.body
              )}
            </div>
            {/* Guests selector trigger */}
            <div ref={guestsAnchorRef} style={{ marginTop: 8, position: 'relative' }}>
              <button type="button" onClick={()=>setShowGuests(true)} style={{ position:'relative', width:'100%', textAlign:'left', background:'#fff', border:'1px solid #111', borderRadius:12, padding:'10px 12px 10px 12px', paddingRight:32 }}>
                <div style={{ fontSize:10, fontWeight:800, letterSpacing:'.04em', color:'#6b7280', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  HÓSPEDES
                </div>
                <div style={{ fontWeight:800, color:'#111827' }}>
                  {`${totalGuests} hóspede${totalGuests>1?'s':''}`}
                  {babies>0?`, ${babies} bebé${babies>1?'s':''}`:''}
                  {pets>0?`, ${pets} pet${pets>1?'s':''}`:''}
                </div>
                <span
                  aria-hidden="true"
                  style={{
                    width: 0,
                    height: 0,
                    borderLeft: '6px solid transparent',
                    borderRight: '6px solid transparent',
                    borderTop: '8px solid #111',
                    display: 'inline-block',
                    position: 'absolute',
                    right: 12,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                  }}
                />
              </button>
              {/* Guests dropdown */}
              {showGuests && (
                <div
                  ref={guestsRef}
                  onWheel={(e)=>{ e.preventDefault(); e.stopPropagation(); const el = e.currentTarget; if (el) { el.scrollTop += e.deltaY; } }}
                  style={{
                    position:'absolute',
                    zIndex:10000,
                    background:'#fff',
                    border:'1px solid #e5e7eb',
                    borderRadius:12,
                    boxShadow:'0 12px 32px rgba(0,0,0,.2)',
                    width:'100%',
                    padding:12,
                    top: 'calc(100% + 8px)',
                    left: 0,
                    maxHeight: 340,
                    overflowY: 'auto',
                    overscrollBehavior: 'contain',
                  }}
                >
                  {[
                    { key:'adults', label:'Adultos', sub:'Com 13 anos ou mais', value: adults, set:setAdults, min:1 },
                    { key:'children', label:'Crianças', sub:'De 2 a 12 anos', value: childrenCount, set:setChildrenCount, min:0 },
                    { key:'babies', label:'Bebés', sub:'Menor de 2', value: babies, set:setBabies, min:0 },
                    { key:'pets', label:'Animais de estimação', sub:'', value: pets, set:setPets, min:0 },
                  ].map((row, i)=>{
                    return (
                      <div key={row.key} style={{ display:'grid', gridTemplateColumns:'1fr auto', alignItems:'center', gap:12, padding:'10px 6px', borderBottom: i<3? '1px solid #f1f5f9':'none' }}>
                        <div>
                          <div style={{ fontWeight:700, color:'#111827' }}>{row.label}</div>
                          {row.sub && <div style={{ fontSize:12, color:'#6b7280' }}>{row.sub}</div>}
                        </div>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                          <button type="button" onClick={()=> row.set(Math.max(row.min, row.value-1))} disabled={row.value<=row.min} style={{ width:32, height:32, borderRadius:'50%', border:'1px solid #e5e7eb', background:'#fff', color:'#111827', opacity: row.value<=row.min?0.4:1 }}>−</button>
                          <div style={{ minWidth:18, textAlign:'center', fontWeight:700 }}>{row.value}</div>
                          <button type="button" onClick={()=> row.set(row.value + 1)} disabled={row.key!=='pets' && (adults + childrenCount + babies >= maxGuests)} style={{ width:32, height:32, borderRadius:'50%', border:'1px solid #e5e7eb', background:'#fff', color:'#111827', opacity: row.key!=='pets' && (adults + childrenCount + babies >= maxGuests)?0.4:1 }}>+</button>
                        </div>
                      </div>
                    );
                  })}
                  <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:8 }}>
                    <button type="button" onClick={()=>setShowGuests(false)} style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:10, background:'#f3f4f6', fontWeight:700 }}>Concluir</button>
                  </div>
                </div>
              )}
            </div>
            <div>
              <textarea ref={messageRef} required value={guestMessage} onChange={(e)=>setGuestMessage(e.target.value)} style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', minHeight: 64 }} placeholder="Escreva a sua mensagem" />
              <small style={{ color: '#6b7280' }}>Dê uma breve apresentação, horários aproximados de check-in e qualquer informação que ajude o anfitrião a recebê-lo melhor.</small>
            </div>
            {bookingMsg && <div style={{ color: '#0f5132', background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 8, padding: 8 }}>{bookingMsg}</div>}
            {/* Resumo preço por noites */}
            {Number(valor) > 0 && nightsBetween(checkin, checkout) > 0 && (
              <div style={{ fontWeight:700, marginTop:6, marginBottom:4 }}>
                {(Number(valor) * nightsBetween(checkin, checkout)).toLocaleString(undefined, { style: 'currency', currency: 'EUR' })} por {nightsBetween(checkin, checkout)} noite{nightsBetween(checkin, checkout)>1?'s':''}
              </div>
            )}
            <button type="submit" disabled={bookingLoading} style={{
              background: '#ba824f',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              fontWeight: 700,
              fontSize: '1rem',
              padding: '10px 0',
              marginTop: 6,
              cursor: 'pointer',
              transition: 'background .18s'
            }}>{bookingLoading ? 'Enviando...' : 'Solicitar Reserva'}</button>
          </form>
          )}
          <div className="host-info">
            <div className="host-avatar">
              <img src={hostAvatar} alt="Host" />
            </div>
            <div className="host-details">
              <h3 className="host-name">{hostName}</h3>
              <p className="host-role" style={{ display:'flex', alignItems:'center', gap:6 }}>
                <span>{hostRole}</span>
                {hostSelo && (
                  <span style={{ background:'#BA824F', color:'#fff', padding:'2px 8px', borderRadius:999, fontSize:12, fontWeight:700 }}>Selo</span>
                )}
              </p>
              {hostAgency && <p className="host-agency">Imobiliária: {hostAgency}</p>}
              {hostLocation && <p className="host-location">Local de trabalho: {hostLocation}</p>} 
              <div className="host-rating">
                <span className="host-rating-stars">{renderStars(hostRating)}</span>
                <span className="host-rating-value">{hostRating.toFixed(1)}</span>
                <span className="host-rating-count">({hostReviews} reviews)</span>
              </div>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:8, marginTop:8 }}>
                {isAfiliado ? (
                  <button type="button" onClick={openAfiliacao} className="action-link" title={`Abrir anúncio no ${afiliacaoNome}`} style={{ justifyContent:'center' }}>
                    <FaExternalLinkAlt style={{ marginRight:6 }} /> Contactar no {afiliacaoNome}
                  </button>
                ) : (
                  <>
                    {hostPhone && (
                      <button
                        type="button"
                        onClick={() => {
                          if (!showPhoneNumber) {
                            handleRevealPhone();
                          } else {
                            fireCall();
                          }
                        }}
                        className="action-link"
                        title={showPhoneNumber ? 'Ligar' : 'Mostrar telefone'}
                        style={{ justifyContent:'center' }}
                      >
                        <FaPhone style={{ marginRight:6 }} />
                        {showPhoneNumber ? hostPhone : maskPhone(hostPhone)}
                      </button>
                    )}
                    <button type="button" onClick={()=>ensureLeadAndThen(openWhatsApp, 'whatsapp')} className="action-link" title="WhatsApp">
                      <FaWhatsapp style={{ marginRight:6 }} /> WhatsApp
                    </button>
                    {hostEmail && (
                      <button type="button" onClick={fireEmail} className="action-link" title="Email">
                        <FaEnvelope style={{ marginRight:6 }} /> Email
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
        
          <div className="action-buttons">
            <button
              className="action-link favorite"
              onClick={() => {
                if (isFavorited(propertyData?.codigoIMOVEL)) {
                  handleUnfavorite(propertyData?.codigoIMOVEL);
                } else {
                  handleFavorite(propertyData?.codigoIMOVEL);
                }
              }}
            >
              <FaHeart className="action-icon" />
              {isFavorited(propertyData?.codigoIMOVEL) ? 'Remover dos Favoritos' : 'Favorito'}
            </button>
            {isAfiliado ? (
              <button type="button" className="action-link" onClick={openAfiliacao}>
                <FaExternalLinkAlt className="action-icon" />
                Ver anúncio no {afiliacaoNome}
              </button>
            ) : (
              <>
                <button type="button" className="action-link" onClick={(e)=>{ e.preventDefault?.(); openContactModal(); }}>
                  Contactar o anfitrião
                </button>
                <button className="action-link" onClick={()=>ensureLeadAndThen(openWhatsApp, 'whatsapp')}>
                  <FaWhatsapp className="action-icon" />
                  WhatsApp do anfitrião
                </button>
              </>
            )}
            <button className="action-link" onClick={handleShare}>
              <FaShare className="action-icon" />
              Compartilhar
            </button>
          </div>
        </div>  </div>
      </div>

      {/* Seção de Imóveis Similares */}
      {Array.isArray(similarProperties) && similarProperties.length > 0 && (
        <section className="similar-properties">
          <h2 className="similar-title">Imóveis Similares</h2>
          <div className="properties-grid">
            {similarProperties.map((p) => (
              <PropertyCard
                key={p.codigoIMOVEL}
                property={{
                  id: p.codigoIMOVEL,
                  fotos: p.fotos,
                  tituloIMOVEL: p.tituloIMOVEL,
                  enderecoIMOVEL: p.enderecoIMOVEL,
                  valorIMOVEL: p.valorIMOVEL,
                  quartosIMOVEL: p.quartosIMOVEL,
                  banheirosIMOVEL: p.banheirosIMOVEL,
                  metragemIMOVEL: p.metragemIMOVEL,
                  vagasgaragemIMOVEL: p.vagasgaragemIMOVEL,
                  tag: p.destaqueIMOVEL ? 'DESTAQUE' : 'NORMAL',
                  slugIMOVEL: p.slugIMOVEL,
                }}
                onCompare={handleCompare}
                onViewPhotos={handleViewPhotos}
                onViewVideo={handleViewVideo}
                onFavorite={(prop)=> handleFavorite(prop?.codigoIMOVEL || prop?.id)}
                onUnfavorite={(prop)=> handleUnfavorite(prop?.codigoIMOVEL || prop?.id)}
                isFavorited={isFavorited(p.codigoIMOVEL)}
              />
            ))}
          </div>
        </section>
      )}

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        url={window.location.href}
      />

      {isContactModalOpen && createPortal(
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
          onClick={(e) => { if (e.target === e.currentTarget) setIsContactModalOpen(false); }}
        >
          <div style={{ background: '#fff', width: '100%', maxWidth: 520, borderRadius: 12, padding: 16, boxShadow: '0 12px 32px rgba(0,0,0,.2)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <h3 style={{ margin: 0 }}>Contactar o anfitrião</h3>
              <button type="button" onClick={() => setIsContactModalOpen(false)} style={{ border: 'none', background: 'transparent', fontSize: 22, cursor: 'pointer' }}>×</button>
            </div>
            {contactError && (
              <div style={{ color: '#b91c1c', background: '#fef2f2', border: '1px solid #fecaca', padding: 8, borderRadius: 8, marginBottom: 8 }}>
                {contactError}
              </div>
            )}
            <form onSubmit={handleContactSubmit}>
              <div style={{ display: 'grid', gap: 10 }}>
                <input type="text" placeholder="Seu nome" value={contactName} onChange={(e) => setContactName(e.target.value)} required disabled={!!user} title={user ? 'Dados do seu perfil' : undefined} style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8, background: user ? '#f9fafb' : '#fff' }} />
                <input type="email" placeholder="Seu e-mail" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} required disabled={!!user} title={user ? 'Dados do seu perfil' : undefined} style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8, background: user ? '#f9fafb' : '#fff' }} />
                <input type="tel" placeholder="O seu telefone" value={contactPhone} onChange={(e) => setContactPhone(e.target.value)} disabled={phoneFromProfile} title={phoneFromProfile ? 'Número do seu perfil' : undefined} style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8, background: phoneFromProfile ? '#f9fafb' : '#fff' }} />
                <textarea placeholder="Escreva aqui a sua mensagem" value={contactText} onChange={(e) => setContactText(e.target.value)} required style={{ padding: 10, border: '1px solid #ddd', borderRadius: 8, minHeight: 120 }} />
              </div>
              <div style={{ fontSize: 12, color: '#4b5563', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8, padding: '8px 10px', marginTop: 8 }}>
                Ao submeter este pedido, os seus dados serão encaminhados ao anunciante para que este possa entrar em contacto consigo. A JoviPlanet é a entidade responsável pelo tratamento dos seus dados pessoais, nos termos da legislação aplicável.
              </div>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
                <button type="button" onClick={() => setIsContactModalOpen(false)} style={{ padding: '10px 14px', border: '1px solid #ddd', background: '#fff', borderRadius: 8 }}>Cancelar</button>
                <button type="submit" disabled={contactLoading} style={{ padding: '10px 14px', border: 'none', background: '#BA824F', color: '#fff', borderRadius: 8, fontWeight: 700 }}>
                  {contactLoading ? 'Enviando...' : 'Enviar mensagem'}
                </button>
              </div>
            </form>
          </div>
        </div>,
        document.body
      )}

      <PhotoViewerModal
        isOpen={isPhotoViewerOpen}
        onClose={() => setIsPhotoViewerOpen(false)}
        images={fotos}
        currentIndex={currentPhotoIndex}
        setCurrentIndex={setCurrentPhotoIndex}
      />
    </>
  );
}

function Property() {
  return (
    <ErrorBoundary>
      <PropertyContent />
    </ErrorBoundary>
  );
}

// Error boundary simples para evitar tela em branco caso ocorra algum erro de renderização
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('Erro ao renderizar Property:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{maxWidth:960,margin:'24px auto',padding:'16px',background:'#fff',border:'1px solid #fee2e2',borderRadius:12}}>
          <h2 style={{marginTop:0,color:'#b91c1c'}}>Ops! Algo deu errado ao carregar este imóvel.</h2>
          <p style={{color:'#374151'}}>Tente voltar e abrir novamente. Se o problema persistir, reporte ao suporte.</p>
          <pre style={{whiteSpace:'pre-wrap',background:'#fff7ed',border:'1px solid #fed7aa',padding:12,borderRadius:8,overflow:'auto'}}>{String(this.state.error)}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export default Property;